import { useState } from "react";
import type { UseWizardProps, WizardAPI } from "./types";
import { useControlledWizard } from "./useControlledWizard";

export const useWizard = <TStep extends string | number | symbol>({
  steps,
  onStepChange,
  onComplete,
}: UseWizardProps<TStep>): WizardAPI<TStep> => {
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  return useControlledWizard({
    steps,
    currentStepIndex,
    setCurrentStepIndex,
    onStepChange,
    onComplete,
  });
};
